import React, { useContext, useEffect } from "react"
import Context from "../utils/Context"
import { sendTaskToRobot } from "../utils/ROS/ROSFunctions"

function ModalLocate() {
    const context = useContext(Context)

    useEffect(() => {
        context.actions.setPreviousConfidence(context.localizationConfidence)
    }, [])

    const execLocation = () => {
        sendTaskToRobot({ actions: [{ value: "Base", name: "publish-pose" }], id: "Base", name: "Locate" })
        context.actions.setModalState({ ...context.modalState, locate: false })
        context.actions.setMessage({ message: "Ok!", type: "success" })
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>

            <div className="modal-card" >
                <header className="modal-card-head">
                    <p className="modal-card-title">Localizar robô</p>

                    <button
                        className="delete"
                        aria-label="close"
                        onClick={() => context.actions.setModalState({ ...context.modalState, locate: false })}
                    ></button>
                </header>

                <section className="modal-card-body">
                    <div className="field mb-5">
                        <div className="columns is-mobile">
                            <label className="label" style={{ fontSize: 20, padding: '10px' }}>
                                De certeza que quer localizar o robô?
                            </label>
                        </div>
                    </div>
                </section>

                <footer className="modal-card-foot">
                    <button className="button is-success" onClick={execLocation}>
                        Sim
                    </button>

                    <button className="button is-danger" onClick={() => context.actions.setModalState({ ...context.modalState, locate: false })}>
                        Não
                    </button>
                </footer>
            </div>
        </div>
    )
}

export default ModalLocate